export const fmtMoney = (n, currency = "USD") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(Number(n));
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(abs);
  return Number(n) < 0 ? `-${formatted}` : formatted;
};

// Compact money formatter — renders $246,281.92 as $246.3K and
// $1,950,000 as $1.95M. Used by the Dashboard "compact numbers" toggle
// so KPI cards stay readable on tiny screens.
export const fmtMoneyCompact = (n, currency = "USD") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(Number(n));
  // Keep sub-$1,000 values precise — compact notation collapses them to "$246"
  // which hides the cents accountants care about.
  if (abs < 1000) {
    return fmtMoney(n, currency);
  }
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    notation: "compact",
    maximumFractionDigits: abs < 10000 ? 2 : 1,
  }).format(abs);
  return Number(n) < 0 ? `-${formatted}` : formatted;
};

export const fmtNumber = (n) => {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("en-US").format(n);
};

// US date format: MM/DD/YYYY everywhere the app shows a calendar date.
// Handles both ISO date-only strings (YYYY-MM-DD) and full ISO timestamps.
// Parses date-only inputs manually to avoid the well-known UTC-to-local shift
// where `new Date("2025-12-15")` shows as Dec 14 in PT timezones.
export const fmtDate = (s) => {
  if (!s) return "—";
  let y, m, d;
  if (typeof s === "string") {
    const dateOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
      y = dateOnly[1]; m = dateOnly[2]; d = dateOnly[3];
      return `${m}/${d}/${y}`;
    }
    const datePrefix = s.match(/^(\d{4})-(\d{2})-(\d{2})T/);
    if (datePrefix) {
      y = datePrefix[1]; m = datePrefix[2]; d = datePrefix[3];
      return `${m}/${d}/${y}`;
    }
  }
  const dt = new Date(s);
  if (isNaN(dt.getTime())) return s;
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${dt.getFullYear()}`;
};

export const fmtMonth = (s) => {
  if (!s) return "—";
  const [y, m] = s.split("-");
  return `${m.padStart(2, "0")}/${y}`;
};
